import React, { useState } from "react";
import ComissionCalculator from "../ComissionCalculator/ComissionCalculator";
import ComissionQuote from "../ComissionQuote/ComissionQuote";

const CalculatorQuoteGenerator = () => {
  const [calc, setCalc] = useState(true);
  const [price, setPrice] = useState(2500000);
  const [dueDiligenceTimeline, setDueDiligenceTimeline] = useState('3-4 weeks');

  return (
    <div className='calculator-main-container'>
      <ComissionCalculator
        setPrice={setPrice}
        dueDiligenceTimeline={dueDiligenceTimeline}
        setDueDiligenceTimeline={setDueDiligenceTimeline}
        price={price}
      />
      <ComissionQuote
        price={price}
        dueDiligenceTimeline={dueDiligenceTimeline}
      />
    </div>
  );
};

export default CalculatorQuoteGenerator;
